import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../../components/button';


const DeleteRequestModal = ({
  show,
  onHide,
  selectedRequest,
  onConfirm
}) => {
  return (
    <Modal show={show} onHide={onHide} centered className="send-request-modal">
      <Modal.Header className="modal-header-custom">
        <Modal.Title className="modal-title-custom">Delete Request</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body-custom">
        <p className="instruction-text">Are you sure you want to delete this request?</p>

        {selectedRequest && (
          <div className="request-details-container">

            <span className="detail-label">Request ID</span>
            <span className="detail-value">{selectedRequest.reqId}</span>


            <span className="detail-label">SKU</span>
            <span className="detail-value">{selectedRequest.sku}</span>


            <span className="detail-label">Product Name</span>
            <span className="detail-value">{selectedRequest.productName}</span>


            <span className="detail-label">Retail Price</span>
            <span className="detail-value">{selectedRequest.retailPrice}</span>

            <span className="detail-label">Discounted Price</span>
            <span className="detail-value">{selectedRequest.discountedPrice}</span>

            <span className="detail-label">Promo Start Date</span>
            <span className="detail-value">{selectedRequest.promoStartDate}</span>

            <span className="detail-label">Promo End Date</span>
            <span className="detail-value">{selectedRequest.promoEndDate}</span>

            <span className="detail-label">After Discounted Price</span>
            <span className="detail-value">{selectedRequest.afterDiscountedPrice}</span>

            <span className="detail-label">Remark by Requester</span>
            <span className="detail-value">00000</span>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="modal-footer-custom">
        <Button className="requester-search-btn" onClick={onConfirm}>Yes, Delete</Button>
        <Button className="requester-search-btn" onClick={onHide}>CANCEL</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteRequestModal;
